<div *ngIf="{card: boletinesCard, mas: boletinesMas} as boletines" style="width: 100%;">
  <div *ngIf="boletines.card !== null && boletines.card !== undefined">
    <div *ngIf="boletines.card.length > 0; else mensajeVacio">
      <mat-card *ngIf="boletines.card.length > 0" style="width: 100%;">
        <mat-card-title><a [routerLink]="url" style="cursor: pointer;">{{boletinesObj.categoriaDisplay}}</a>
        </mat-card-title>
        <mat-card-content>
          <div class="badges">
            <div *ngFor="let boletin of boletines.card">
              <app-glm-badge [display]="boletin.reconocimiento.nickname" [toolTip]="boletin.reconocimiento.nombre"
                [imgName]="boletin.reconocimiento.badge" [pequeno]="true">
              </app-glm-badge>
            </div>
          </div>
          <div style="width: 56px; height: 56px; display: flex; justify-content: center; align-items: center;"
            *ngIf="boletines.mas.length > 0">
            <a [matMenuTriggerFor]="menu">{{boletines.mas.length + ' más'}}</a>
          </div>
          <mat-menu #menu="matMenu">
            <div *ngFor="let boletin of boletines.mas">
              <app-glm-badge [display]="boletin.reconocimiento.nickname" [toolTip]="boletin.reconocimiento.nombre"
                [imgName]="boletin.reconocimiento.badge" [pequeno]="true">
              </app-glm-badge>
              <p>{{boletin.nombre}}</p>
            </div>
          </mat-menu>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #mensajeVacio>
      <mat-card>
        <mat-card-title>
          <a [routerLink]="url" style="cursor: pointer;">{{boletinesObj.categoriaDisplay}}</a>
        </mat-card-title>
        <mat-card-content>
          No tienes reconocimientos en esta categoría. ¡No te rindas!
        </mat-card-content>
      </mat-card>
    </ng-template>
  </div>
</div>